module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories-fdfcb8be65bdc2875cc647c70faf972f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories.svg
// module id = j2d0
// module chunks = 24